module.exports = __webpack_public_path__ + "static/fonts/Mont-SemiBoldItalic.96122e9.woff";